import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../style/confirmation.css";

// Function to format the date as DD-MMM-YYYY
const formatDate = (dateString) => {
  const date = dateString ? new Date(dateString) : new Date();
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options).replace(",", "");
};

function Confirmation() {
  const location = useLocation();
  const navigate = useNavigate();

  console.log("Location State:", location.state); // Debugging to check received data

  // Extract details from navigation state
  const { 
    wing, 
    flat, 
    mobileNumber, 
    name, 
    date, 
    previousReading, 
    currentReading, 
    waterUsage, 
    billFileName 
  } = location.state || {};

  return (
    <div className="confirmation-page">
      {/* Sticky Navbar */}
      <nav className="confirmation-navbar">
        <div className="confirmation-logo">💧</div>
      </nav>

      {/* Content */}
      <div className="confirmation-content">
        <div className="confirmation-box">
          <h2 className="confirmation-message">✅ Reading Captured Successfully! ✅</h2>

          {/* Check if values exist before displaying */}
          {/* <p><strong>Wing:</strong> {wing || "N/A"}</p> */}
          <p><strong>Flat No:</strong> {flat || "N/A"}</p>
          <p><strong>Mobile No:</strong> {mobileNumber ? mobileNumber : "Not Provided"}</p>
          <p><strong>Name:</strong> {name ? name : "Not Provided"}</p>
          <p><strong>Date:</strong> {formatDate(date)}</p> {/* Formats date in DD-MMM-YYYY */}
          {/* <p><strong>Previous Reading:</strong> {previousReading || "N/A"}</p> */}
          <p><strong>Current Reading:</strong> {currentReading + "units" || "N/A"}</p>
          {/* <p><strong>Water Usage:</strong> {waterUsage ? `${waterUsage} units` : "N/A"}</p> */}
          <p><strong>Image Uploaded:</strong> {billFileName || "No File"}</p>
        </div>
      </div>

      {/* Fixed Submit Button */}
      <button className="confirm-btnss" onClick={() => navigate("/")}>
        Back to Home
      </button>

      {/* Bottom Navigation */}
      {/* <footer className="confirmation-bottom-nav">
        <button className="confirmation-nav-btn" onClick={() => navigate("/home")}>Home</button>
        <button className="confirmation-nav-btn" onClick={() => navigate("/menu")}>Readings</button>
        <button className="confirmation-nav-btn" onClick={() => navigate("/report")}>Report</button>
      </footer> */}
       <div className="footers">
        <p>powered by @Dexpert Systems</p>
      </div>
    </div>
  );
}

export default Confirmation;
